




































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';

const Props = Vue.extend({
	props: {
		/** Number of items */
		itemsNumber: {
			type: Number,
			default: 1
		},
		/** Heading Loading option */
		heading: {
			type: Boolean,
			default: false
		},
		row: {
			type: Boolean,
			default: false
		},
		flex: {
			type: Boolean,
			default: false
		},
		/** The item width */
		itemWidth: {
			type: String,
			default: '200px'
		}
	}
});

const MixinsDeclaration = mixins(Props);

@Component
export default class DataListLoading extends MixinsDeclaration {
	get listClass(): string {
		return this.flex ? 'flex-wrap' : 'flex-column';
	}
}
